import { ViewportScroller } from '@angular/common';
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[ccScrollToTop]'
})
export class CcScrollToTopDirective {

  constructor(private scroll: ViewportScroller) { }
  @HostListener('click')
  onClick(): void {
    this.scroll.scrollToPosition([0,0]);
  }
}
